import React from "react";
import {Table} from "react-bootstrap";
import locale from "../../../../locale";

export default ({ quizzes, event, onAnswerClick }) => {
    if (!quizzes.length) return null;

    const correctAnswerStyles = {
        borderColor: '#40AF40',
        borderStyle: 'solid',
    };

    return (
        <section>
            {quizzes.map((quiz) => (
                <div key={quiz.id}>
                    <Table>
                        <thead>
                        <tr>
                            <th style={{ fontSize: '18px' }}>
                                {locale.field(quiz, 'title')}
                            </th>
                            <th style={{ width: 80 }}>{locale('spectators')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {quiz.polls?.map((poll) =>
                            <React.Fragment key={poll.id}>
                                <tr>
                                    <td style={{ fontWeight: 'bold' }}>
                                        {locale.field(poll, 'text')}
                                        <span style={{ marginLeft: 10, fontWeight: 'normal', color: 'red' }}>
                                            {locale('quiz.type.' + poll.type)}
                                        </span>
                                    </td>
                                    <td />
                                </tr>
                                {poll.answer?.map((answer) => (
                                    <tr key={answer.id}>
                                        <td style={ answer.isCorrect ? { ...correctAnswerStyles, borderWidth: '1px 0px 1px 1px' } : {} }>
                                            {(!event.client.allowPrivateClientDataAccess || !quiz.authorizationRequired)
                                                ? <a onClick={() => onAnswerClick(answer)}>{locale.field(answer, 'text')}</a>
                                                : <>{locale.field(answer, 'text')}</>
                                            }
                                        </td>
                                        <td style={ answer.isCorrect ? { ...correctAnswerStyles, borderWidth: '1px 1px 1px 0px' } : {} }>
                                            {answer.count}
                                        </td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        )}
                        </tbody>
                    </Table>
                </div>
            ))}
        </section>
    );
}
